export const navigation = /*html*/`
<nav>
<ul>
  <li><a href="#section1" id="nav1"><h1></h1>home</a></li>
  <li><a href="#section2" id="nav2"><h1></h1>data</a></li>
  <li><a href="#section3" id="nav3"><h1></h1>contact</a></li>
</ul>
</nav>
`